module.exports = __webpack_public_path__ + "img/Google_play-badge.ac034471.png";